import axios from "axios";

const api_key = process.env.REACT_APP_API_KEY;

const attachAuthHeaders = (config) => {
  const token = sessionStorage.getItem("wsstfaarvav");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  if (api_key) {
    config.headers["x-api-key"] = api_key;
  }
  return config;
};

export const instance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

export const imageInstance = axios.create({
  headers: {
    Accept: "multipart/form-data",
    "Content-Type": "multipart/form-data",
  },
});

instance.interceptors.request.use(attachAuthHeaders);
imageInstance.interceptors.request.use(attachAuthHeaders);
